import React, { useState } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import * as Yup from "yup";
import { injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { requestPassword } from "../_redux/authCrud";
import useSnackbarContext from "../../../core/hooks/useSnackbarContext";

const initialValues = {
  email: "",
};

function ForgotPassword(props) {

  const toast = useSnackbarContext()

  const { intl } = props;
  const [isRequested, setIsRequested] = useState(false)
  const [requestErrors, setRequestErrors] = useState({})
  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email("Wrong email format")
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      requestPassword(values.email)
        .then(() => {
          setIsRequested(true)
          toast('Solicitud enviada correctamente, revise su correo')
        })
        .catch((error) => {
          if (error.response) {

            const errors = error.response.data 
            let new_errors = {}
            for (const key of Object.keys(errors)) {
              if (Array.isArray(errors[key]) && errors[key].length > 0) {
                if (errors[key][0] === "We couldn't find an account associated with that email. Please try a different e-mail address.")  {
                  new_errors[key] = 'No se ha encontrado una cuenta asociada a este correo'
                } else {
                  new_errors[key] = errors[key][0]
                }
              } else if (typeof errors[key] == 'string') {
                if (errors[key] === "We couldn't find an account associated with that email. Please try a different e-mail address.")  {
                  new_errors[key] = 'No se ha encontrado una cuenta asociada a este correo'
                } else {
                  new_errors[key] = errors[key]
                }
              }
            }
            setRequestErrors(new_errors)
            
          }
          toast('Ha ocurrido un error al enviar la recuperación de contraseña', 'danger')
          setIsRequested(false);
          setSubmitting(false);
          setStatus(
            intl.formatMessage(
              { id: "AUTH.VALIDATION.NOT_FOUND" },
              { name: values.email }
            )
          );
        });
    },
  });

  return (
    <>
      {isRequested && <Redirect to="/auth" />}
      {!isRequested && (
        <div className="login-form login-forgot" style={{ display: "block" }}>
          <div className="text-center mb-10 mb-lg-20">
            <h3 className="font-size-h1">¿Olvidaste tu contraseña?</h3>
            <div className="text-muted font-weight-bold">
              Ingresa tu email para restablecer tu contraseña
            </div>
          </div>
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
          >
            <div className="form-group fv-plugins-icon-container">
              <input
                type="email"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "email"
                )}`}
                name="email"
                {...formik.getFieldProps("email")}
              />
              {requestErrors.email && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{requestErrors.email}</div>
                </div>
              )}
            </div>
            <div className="form-group d-flex flex-wrap flex-center">
              <button
                id="kt_login_forgot_submit"
                type="submit"
                className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
                disabled={formik.isSubmitting}
              >
                Submit
              </button>
              <Link to="/auth">
                <button
                  type="button"
                  id="kt_login_forgot_cancel"
                  className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
                >
                  Cancel
                </button>
              </Link>
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(ForgotPassword));
